module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.cbdecee7.ttf";